import { render, staticRenderFns } from "./UserPlan.vue?vue&type=template&id=33b79228&scoped=true&"
import script from "./UserPlan.vue?vue&type=script&lang=js&"
export * from "./UserPlan.vue?vue&type=script&lang=js&"
import style0 from "./UserPlan.vue?vue&type=style&index=0&id=33b79228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b79228",
  null
  
)

export default component.exports